import Button from "@atoms/button";
import { Input } from "@atoms/input";
import { Loader } from "@atoms/loader/loader";
import React, { FC } from "react";
import { Trans, useTranslation } from "next-i18next";
import styled from "styled-components";
import { ContactFormData } from "./types";
import { useForm } from "react-hook-form";
import { ContactSectionFormProps } from "@organisms/contact-section";

export const ContactForm: FC<ContactSectionFormProps<ContactFormData>> = ({
  sending,
  onSubmit,
}) => {
  const { t } = useTranslation("forms");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ContactFormData>();

  return (
    <Container>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Input
          placeholder={t("name")}
          type="text"
          endAddorment="user"
          className="form-name"
          disabled={sending}
          error={!!errors.name}
          errorMessage={errors.name?.message}
          {...register("name", {
            required: t("validation.required").toString(),
          })}
        />
        <Input
          placeholder={t("email")}
          type="email"
          endAddorment="at-sign"
          className="form-email"
          disabled={sending}
          error={!!errors.email}
          errorMessage={errors.email?.message}
          {...register("email", {
            required: t("validation.required").toString(),
            pattern: {
              value: /^.+?@.+?\..+?$/i,
              message: t("validation.bad-format").toString(),
            },
          })}
        />
        <Input
          placeholder={t("phone")}
          type="tel"
          endAddorment="at-sign"
          className="form-phone"
          disabled={sending}
          error={!!errors.phone}
          errorMessage={errors.phone?.message}
          {...register("phone", {
            required: t("validation.required").toString(),
          })}
        />
        <Input
          type="textarea"
          className="form-message"
          placeholder={t("message")}
          rows={4}
          disabled={sending}
          error={!!errors.message}
          errorMessage={errors.message?.message}
          {...register("message", {
            required: t("validation.required").toString(),
          })}
        />
        <div className="form-action">
          <Button variant="action" disabled={sending}>
            {sending && (
              <div className="btn-loader">
                <Loader />
              </div>
            )}
            {t("send")}
          </Button>
        </div>
      </Form>
    </Container>
  );
};

const Container = styled.div``;

const Form = styled.form`
  display: flex;
  gap: 1em;
  flex-direction: column;

  .form-action {
    grid-area: form-action;
    display: flex;
    justify-content: flex-end;

    button {
      font-size: 1.2em;
      min-width: 9em;
      justify-content: center;
      align-items: center;
      position: relative;

      > .btn-loader {
        position: absolute;
        top: 0;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
`;
